import { Injectable } from '@angular/core'
import { AggregateAccountInfo } from '@helios/state-management'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AccountListGridService {
  private readonly selectedAggregateForFilter = new BehaviorSubject<
    AggregateAccountInfo | undefined
  >(undefined)

  readonly selectedAggregateForFilter$ =
    this.selectedAggregateForFilter.asObservable()

  setSelectedAggregateForFilter(account: AggregateAccountInfo) {
    this.selectedAggregateForFilter.next(account)
  }

  clearSelectedAggregateForFilter() {
    this.selectedAggregateForFilter.next(undefined)
  }
}
